package com.rainbowclubs.rainbow.domain.use_cases.user

import com.rainbowclubs.rainbow.data.models.User
import com.rainbowclubs.rainbow.domain.repositories.UserRepository

class GetUserUseCase(
    private val userRepository: UserRepository,
) {
    operator fun invoke(): User? {
        return userRepository.getCurrentUser()
    }
}
